module.exports = __webpack_public_path__ + "img/kyano-account-logo-dark.9e87396d.svg";